import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsOverlayService {
  private _showSettings = new BehaviorSubject<boolean>(false);
  showSettings$: Observable<boolean> = this._showSettings.asObservable();

  private _initialTab = new BehaviorSubject<string | undefined>(undefined);
  initialTab$: Observable<string | undefined> = this._initialTab.asObservable();

  constructor() {}

  openSettings(initialTab?: string) {
    this._initialTab.next(initialTab);
    this._showSettings.next(true);
  }

  closeSettings() {
    this._showSettings.next(false);
    this._initialTab.next(undefined);
  }
}
